import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f1e0296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1))
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "form-group row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Type", -1))
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Mobile", -1))
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1))
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Google calendar email", -1))
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Address", -1))
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address Line 2")
], -1))
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "form-group row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "City", -1))
const _hoisted_24 = { class: "col-sm-3" }
const _hoisted_25 = { class: "form-group row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "County", -1))
const _hoisted_27 = { class: "col-sm-3" }
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Postcode", -1))
const _hoisted_30 = { class: "col-sm-2" }
const _hoisted_31 = { class: "form-group row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Mode of transport", -1))
const _hoisted_33 = { class: "col-sm-2" }
const _hoisted_34 = { class: "form-group row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Region", -1))
const _hoisted_36 = { class: "col-sm-2" }
const _hoisted_37 = { class: "form-group row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Active", -1))
const _hoisted_39 = { class: "col-sm-2" }
const _hoisted_40 = { class: "form-group row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Picture", -1))
const _hoisted_42 = { class: "col-sm-9" }
const _hoisted_43 = { class: "form-group row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Signature", -1))
const _hoisted_45 = { class: "col-sm-9" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-1x fas fa-paste" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = ["src"]

import _ from "lodash";
import _get from "lodash/get";
import { ref, computed } from "vue";
import Logos from "@/components/logo/Logos.vue";
import { Inspector } from "@/models";
import { useStore } from "vuex";
import { DxSwitch } from "devextreme-vue/switch";
import { useToast } from "vue-toastification";

export default /*#__PURE__*/_defineComponent({
  __name: 'Address',
  setup(__props) {

const toasted = useToast();
const store = useStore();
const transportmodes = ref<string[]>(["Bike", "Car", "Train", "Walking"]);
const inspector = computed(() => store.getters["inspectors/current"]);
const editInspector = async (inspector: Inspector) =>
  await store.dispatch("inspectors/editInspector", inspector);
const regionlist = ref<string[]>([
  "Region 1",
  "Region 2",
  "Region 3",
  "Region 4",
  "Region 5",
  "Region 6",
  "Region 7",
  "Region 8",
  "Region 9",
]);
const setInspectorDeep = (payload: {
  path: string;
  data: any;
}): Promise<any> => {
  return store.dispatch("inspectors/setInspectorDeep", payload);
};

const editCurrentInspector = () => {
  editInspector(inspector.value);
};

const active = computed({
  get: () => !inspector.value.inactive,
  set: (data) => {
    let val: boolean = data === true ? false : true;
    setInspectorDeep({ path: "inactive", data: val });
  },
});

const getPicture = computed(() => {
  let photos: string[] = [];
  return _get(inspector.value, "picture", photos);
});


const isBase64 = (base64String:string) => {
  // Create an image object
  const img = new Image();
  
  // Set the source to the base64 string
  img.src = `data:image/jpeg;base64,${base64String}`;
  
  // Check if the image loaded successfully
  return img.complete && img.naturalWidth !== 0;
}

const pasteSignature = async () => {
  const text = await navigator.clipboard.readText();    
  if(text && isBase64(text)) {
    setInspectorDeep({ path: "signature", data: text });
    toasted.success("Signature pasted");
  } else {
    toasted.error('Format of the signature is not proper or blank')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inspector.value.name) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [_vModelText, inspector.value.name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              maxlength: "8",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inspector.value.itype) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [_vModelText, inspector.value.itype]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inspector.value.mobile) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [_vModelText, inspector.value.mobile]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inspector.value.email) = $event)),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [_vModelText, inspector.value.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inspector.value.googlecalendaremail) = $event)),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [_vModelText, inspector.value.googlecalendaremail]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inspector.value.address.line1) = $event)),
              onChange: _cache[11] || (_cache[11] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [
                _vModelText,
                inspector.value.address.line1,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((inspector.value.address.line2) = $event)),
              onChange: _cache[13] || (_cache[13] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [
                _vModelText,
                inspector.value.address.line2,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((inspector.value.address.town) = $event)),
              onChange: _cache[15] || (_cache[15] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [
                _vModelText,
                inspector.value.address.town,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((inspector.value.address.county) = $event)),
              onChange: _cache[17] || (_cache[17] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [
                _vModelText,
                inspector.value.address.county,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((inspector.value.address.postcode) = $event)),
              onChange: _cache[19] || (_cache[19] = ($event: any) => (editCurrentInspector()))
            }, null, 544), [
              [
                _vModelText,
                inspector.value.address.postcode,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_singleselect_text, {
              modelValue: inspector.value.transport,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((inspector.value.transport) = $event)),
              value: inspector.value.transport,
              options: transportmodes.value,
              onSelect: _cache[21] || (_cache[21] = ($event: any) => (editCurrentInspector()))
            }, null, 8, ["modelValue", "value", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_singleselect_text, {
              modelValue: inspector.value.region,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((inspector.value.region) = $event)),
              value: inspector.value.region,
              options: regionlist.value,
              onSelect: _cache[23] || (_cache[23] = ($event: any) => (editCurrentInspector()))
            }, null, 8, ["modelValue", "value", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_unref(DxSwitch), {
              modelValue: active.value,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((active).value = $event)),
              onValueChanged: _cache[25] || (_cache[25] = ($event: any) => (active.value = $event.value))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            (_openBlock(), _createBlock(Logos, {
              key: `row${inspector.value._uuid}${getPicture.value.length}`,
              photos: getPicture.value,
              path: 'picture',
              target: 'inspector'
            }, null, 8, ["photos"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (pasteSignature()), ["prevent"]))
            }, [
              _createTextVNode(" Paste "),
              _hoisted_46
            ]),
            _hoisted_47,
            (inspector.value.signature)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: `data:image/jpeg;base64,${inspector.value.signature}`,
                  class: "image"
                }, null, 8, _hoisted_48))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})